import { Command } from 'commander';
import { ApiClient } from '../client.js';
import { formatOutput } from '../output.js';
import { getBase, getFormat } from '../helpers.js';
import { requireActiveOrg } from '../require-active-org.js';

// Seed fixtures (#605): apply / reset / clear a named fixture on a PREVIEW base for hermetic evals.
// Fixtures are authored as config-as-code (`rekor-ws/bases/<base>/seeds/<name>.yaml`) and pushed with
// `rekor push`; these verbs then drive the STORED fixture by name (no body). Preview-only, enforced
// server-side. The fixture stamps a reserved ownership marker so reset/clear revert exactly its rows.
export const seedCommand = new Command('seed')
  .description('Apply, reset, or clear a seed fixture on a preview base (hermetic eval data)');

seedCommand.command('apply <name>')
  .description('Idempotently upsert the fixture (keyed by external_id, so re-applying never twins). Preview-only.')
  .action(async function (this: Command, name: string) {
    await requireActiveOrg();
    const ws = getBase(this);
    const client = new ApiClient();
    const data = await client.request('POST', `/v1/${ws}/seeds/${name}/apply`);
    console.log(formatOutput(data, getFormat(this)));
  });

seedCommand.command('reset <name>')
  .description('Restore the declared baseline: re-apply in place (fixing trigger-mutated records) and prune owned rows the fixture no longer declares. Preview-only.')
  .action(async function (this: Command, name: string) {
    await requireActiveOrg();
    const ws = getBase(this);
    const client = new ApiClient();
    const data = await client.request('POST', `/v1/${ws}/seeds/${name}/reset`);
    console.log(formatOutput(data, getFormat(this)));
  });

seedCommand.command('clear <name>')
  .description('Delete every row the fixture owns (teardown). Preview-only.')
  .action(async function (this: Command, name: string) {
    await requireActiveOrg();
    const ws = getBase(this);
    const client = new ApiClient();
    const data = await client.request('POST', `/v1/${ws}/seeds/${name}/clear`);
    console.log(formatOutput(data, getFormat(this)));
  });

seedCommand.command('list')
  .description('List the seed fixtures defined on a base')
  .action(async function (this: Command) {
    const ws = getBase(this);
    const client = new ApiClient();
    const data = await client.request('GET', `/v1/${ws}/seeds`);
    console.log(formatOutput(data, getFormat(this)));
  });

seedCommand.command('get <name>')
  .description('Show a seed fixture definition (its declared records and relationships)')
  .action(async function (this: Command, name: string) {
    const ws = getBase(this);
    const client = new ApiClient();
    const data = await client.request('GET', `/v1/${ws}/seeds/${name}`);
    console.log(formatOutput(data, getFormat(this)));
  });
